// URL search params of the Engineering changes page (PX-ENG-310). Kept apart
// from the page module so the route config (entry chunk) does not pull it in.
import { ecoListColumns } from "@patronix/domain/list";
import { viewSearch, type ViewSearch } from "@/lib/listView";
import { ecoFilters, type EcoFilter } from "./api";

export interface EcoSearch extends ViewSearch {
  status: EcoFilter;
  q: string;
  id?: string | undefined;
  /** The import panel is open (replaces the detail). */
  import?: true | undefined;
}

export function validateEcoSearch(raw: Record<string, unknown>): EcoSearch {
  const s: EcoSearch = {
    status: ecoFilters.includes(raw.status as EcoFilter) ? (raw.status as EcoFilter) : "open",
    q: typeof raw.q === "string" ? raw.q.slice(0, 100) : "",
  };
  if (typeof raw.id === "string" && raw.id) s.id = raw.id;
  if (raw.import === true || raw.import === "true") s.import = true;
  return { ...s, ...viewSearch(ecoListColumns, raw) };
}
